import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';
import moment from 'utils/moment';
import styles from './list.module.scss';
import icon from '../../icons/GateModule.png';
import SectionHeader from '../../components/sectionHeader';
import HeaderBack from '../../components/headerBack';
import Panel from '../../components/panel';
import Button from '../../components/button';
import PulpoField from '../../pulpo_visualizer/fields';
import { getdetail, updateData, clearData } from './redux/actions';

const PlanDataUpdate = ({ actiongetDetail, match, detail, actionUpdate, updateAction, history, actionClear }) => {
  const [list, setList] = useState({});
  const [showErrors, setShowErrors] = useState(false);
  const [dateValidationError, setDateValidationError] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    type: false,
    gate: false,
    flight: false,
    airline: false,
    departure_city: false,
    arrival_city: false,
    scheduled_departure: false,
    scheduled_arrival: false,
    aircraft_type: false,
    operation_days: false
  });
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  useEffect(() => {
    if (match?.params?.id) {
      actiongetDetail(match?.params?.id);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (updateAction.success===true) {
      history.push('/gateManagement');
      actionClear();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateAction]);

  useEffect(() => {
    if (match?.params?.id) {
      if (detail) {
        const operationDays = handleChangeOperationDays(detail.operation_days);
        const data = {
          type: detail.schedule_type || '',
          gate: detail.gate_key || '',
          tail: detail.tail_number || '',
          arrival_flight: detail.arrival_flight_number || '',
          dep_flight: detail.departure_flight_number || '',
          airline: detail.airline || '',
          arrival_from: detail.from_city_icao || '',
          departure_to: detail.to_city_icao || '',
          scheduled_arrival: moment(detail?.schedule_arrival, 'hh:mm A') || '',
          scheduled_departure: moment(detail?.schedule_departure, 'hh:mm A') || '',
          group_name: detail?.info?.group_name,
          type_service: detail?.info?.type_service,
          aircraft_type: detail.aircraft_type || '',
          operation_days: operationDays?.map(e => ({ label: e, value: e })),
          over_night: detail.over_night || ''
        };
        if (detail?.start_date) {
          data.start_date = moment(detail?.start_date) || '';
        }
        if (detail?.end_date) {
          data.end_date = moment(detail?.end_date) || '';
        }
        setList(data);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail, match]);

  const handleAnswerChanged = (a, b) => {
    setList({ ...list, [b]: a });
    if (b==='operation_days') {
      if (a?.length > 0 && a!== null && a!=='') {
        handleFieldErrorChanged(b, false);
      } else {
        handleFieldErrorChanged(b, true);
      }
    }
    if (b === 'scheduled_departure' && list?.schedule_arrival) {
      if (moment(list?.scheduled_arrival).isSameOrAfter(moment(a))) {
        setDateValidationError('schedule');
      } else {
        setDateValidationError(false);
      }
    }
    if (b === 'scheduled_arrival' && list?.schedule_departure) {
      if (moment(a).isSameOrAfter(moment(list?.scheduled_departure))) {
        setDateValidationError('schedule');
      } else {
        setDateValidationError(false);
      }
    }
    if (b === 'start_date' && list?.end_date) {
      if (moment(a).isAfter(moment(list?.end_date), 'day')) {
        setDateValidationError('dates');
      } else {
        setDateValidationError(false);
      }
    }
    if (b === 'end_date' && list?.start_date) {
      if (moment(list?.start_date).isAfter(moment(a), 'day')) {
        setDateValidationError('dates');
      } else {
        setDateValidationError(false);
      }
    }
    if (b === 'over_night' && a === 'Y') {
      if (moment(list?.start_date).format('YYYY-MM-DD') === moment(list?.end_date).format('YYYY-MM-DD')) {
        setDateValidationError('overnight');
      } else {
        setDateValidationError(false);
      }
    }
  };

  const handleFieldErrorChanged = (id, value) => {
    setFieldErrors({
      ...fieldErrors, [id]: value });
  };

  const handleChangeOperationDays = (day) => {
    const data = [];
    if (day) {
      day.map((d) => {
        switch (d) {
          case 0:
            data.push('Monday');
            break;
          case 1:
            data.push('Tuesday');
            break;
          case 2:
            data.push('Wednesday');
            break;
          case 3:
            data.push('Thursday');
            break;
          case 4:
            data.push('Friday');
            break;
          case 5:
            data.push('Saturday');
            break;
          case 6:
            data.push('Sunday');
            break;
          case 7:
            data.push('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
            break;
          default:
            break;
        }
        return null;
      });
    }
    return data;
  };

  const handleOperationDays = (day) => {
    const data = [];
    if (day?.length===7) { days.splice(0, 7, 'Everyday'); }
    day.map((d) => {
      switch ((d.trim()).toUpperCase()) {
        case 'MONDAY':
          data.push(0);
          break;
        case 'TUESDAY':
          data.push(1);
          break;
        case 'WEDNESDAY':
          data.push(2);
          break;
        case 'THURSDAY':
          data.push(3);
          break;
        case 'FRIDAY':
          data.push(4);
          break;
        case 'SATURDAY':
          data.push(5);
          break;
        case 'SUNDAY':
          data.push(6);
          break;
        case 'EVERYDAY':
          data.push(7);
          break;
        default:
          break;
      }
      return null;
    });
    return data;
  };

  const handleEdit = () => {
    if (fieldErrors) {
      const noErrors = Object.keys(fieldErrors).every(
        k => fieldErrors[k] === false
      );
      if (noErrors && !dateValidationError) {
        const data = {};
        data.schedule_type = list?.type;
        data.gate_key = list?.gate;
        data.tail_number = list?.tail;
        data.arrival_flight_number = list?.arrival_flight;
        data.departure_flight_number = list?.dep_flight;
        data.airline = list?.airline;
        data.from_city_icao = list?.arrival_from;
        data.to_city_icao = list?.departure_to;
        data.schedule_arrival = moment(list?.scheduled_arrival).format('HH:mm');
        data.schedule_departure = moment(list?.scheduled_departure).format('HH:mm');
        data.aircraft_type = list?.aircraft_type;
        data.operation_days = handleOperationDays(list?.operation_days.map(e => e.value));
        data.over_night = list?.over_night;
        data.start_date = list?.start_date && moment(list?.start_date).format('YYYY-MM-DD');
        data.end_date = list?.end_date && moment(list?.end_date).format('YYYY-MM-DD');
        data.info = {
          ...(detail?.info || {}),
          type_service: list?.type_service,
          group_name: list?.group_name
        };
        actionUpdate(match?.params?.id, data);
      } else {
        setShowErrors(true);
      }
    } else {
      setShowErrors(true);
    }
  };

  return (
    <div>
      <SectionHeader
        icon={icon}
        translationID="gate.edit.title"
        defaultTitle="Manage Gates"
      />
      <HeaderBack
        translationID="asset.new.prev"
        translationDefault="Back to Schedule"
        backRoute="/gateManagement"
      />
      <Panel title="gate.edit.title" defaultTitle="Edit" containerClasses={styles.mainPanel} fromGate>
        <div className={styles.content}>
          <div className={styles.halfformfield}>
            <PulpoField
              key="type"
              id="type"
              type="string"
              translationID="gate.create.name"
              title="Schedule Type"
              answer={list?.type}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.type && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <PulpoField
              key="gate"
              id="gate"
              type="string"
              translationID="gate.create.serial"
              title="Gate #"
              answer={list?.gate}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.gate && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
          <div className={styles.halfformfield}>
            <PulpoField
              key="tail"
              id="tail"
              type="string"
              translationID="gate.create.name"
              title="Tail #"
              answer={list?.tail}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.tail && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <PulpoField
              key="arrival_flight"
              id="arrival_flight"
              type="string"
              translationID="gate.create.serial"
              title="Arrival Flight #"
              isRequired
              answer={list?.arrival_flight}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.arrival_flight && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
          <div className={styles.halfformfield}>
            <PulpoField
              key="dep_flight"
              id="dep_flight"
              type="string"
              translationID="gate.create.serial"
              title="Departure Flight #"
              isRequired
              answer={list?.dep_flight}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.dep_flight && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <PulpoField
              key="airline"
              id="airline"
              type="string"
              translationID="gate.create.serial"
              title="Airline Name"
              answer={list?.airline}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.airline && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
          <div className={styles.halfformfield}>
            <PulpoField
              key="arrival_from"
              id="arrival_from"
              type="string"
              translationID="gate.create.serial"
              title="Origin Airport"
              isRequired
              answer={list?.arrival_from}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.arrival_city && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <PulpoField
              key="departure_to"
              id="departure_to"
              type="string"
              translationID="gate.create.name"
              title="Destination Airport"
              isRequired
              answer={list?.departure_to}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.departure_city && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
          <div className={styles.halfformfield}>
            {list && list.scheduled_arrival
                && (
                <PulpoField
                  key="scheduled_arrival"
                  id="scheduled_arrival"
                  type="datetime"
                  onlyTime
                  isRequired
                  fromGate
                  translationID="gate.create.serial"
                  title="Schedule Time of Arrival(STA)"
                  answer={list.scheduled_arrival}
                  handleValueChange={(a, b) => handleAnswerChanged(a, b)}
                  showFieldErrors={fieldErrors.scheduled_arrival && showErrors}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                />
                )
            }
            {list && list.scheduled_departure
                && (
                <PulpoField
                  key="scheduled_departure"
                  id="scheduled_departure"
                  type="datetime"
                  onlyTime
                  fromGate
                  isRequired
                  title="Schedule Time of Departure(STD)"
                  translationID="gate.create.name"
                  answer={list?.scheduled_departure}
                  handleValueChange={(a, b) => handleAnswerChanged(a, b)}
                  showFieldErrors={fieldErrors.scheduled_departure && showErrors}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                />
                )
            }
          </div>
          {dateValidationError === 'schedule' && (
                <span style={{ color: 'red', fontSize: '11px' }}>
                  <FormattedMessage
                    id="pulpoforms.errors"
                    defaultMessage="*Please Make Sure start time is before end time"
                  />
                </span>
                )
              }
          <div className={styles.halfformfield}>
            <PulpoField
              key="aircraft_type"
              id="aircraft_type"
              type="string"
              translationID="gate.create.name"
              title="Aircraft Type"
              answer={list?.aircraft_type}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.aircraft_type && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <div className={styles.input} style={{ width: '362px' }}>
              <font style={{ color: 'red' }}>*</font>
              <FormattedMessage
                id="gate.users.days"
                defaultMessage="Days of Operations"
              />
                <Select
                isMulti
                value={list?.operation_days}
                onChange={e => handleAnswerChanged(e, 'operation_days')}
                options={days?.map(e => ({
                  label: e,
                  value: e
                }))}
                maxMenuHeight={300}
              />
              {showErrors && fieldErrors.operation_days
                     && (
                     <span style={{ color: 'red', fontSize: '11px' }}>
                       <FormattedMessage
                         id="pulpoforms.errors.not_blank"
                         defaultMessage="This field cannot be empty"
                       />
                     </span>
                     )
                     }
            </div>
          </div>
          <div className={styles.halfformfield}>
            <PulpoField
              key="over_night"
              id="over_night"
              type="select"
              translationID="gate.create.name"
              title="Overnight"
              values={[
                {
                  key: 'Y',
                  value: 'Yes'
                },
                {
                  key: 'N',
                  value: 'No'
                }
              ]}
              isRequired
              answer={list?.over_night}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.over_night && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
          {dateValidationError === 'overnight' && (
                <span style={{ color: 'red', fontSize: '11px' }}>
                  <FormattedMessage
                    id="pulpoforms.errors"
                    defaultMessage="*Please Make Sure End Date is After Start Date"
                  />
                </span>
                )
              }
          <div className={styles.halfformfield}>
            {list && list.start_date && (
              <PulpoField
                key="start_date"
                id="start_date"
                type="date"
                translationID="gate.create.serial"
                title="Start Date"
                answer={list.start_date}
                handleValueChange={(a, b) => handleAnswerChanged(a, b)}
                showFieldErrors={fieldErrors.start_date && showErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
              />
            )}
            {list && list.end_date && (
              <PulpoField
                key="end_date"
                id="end_date"
                type="date"
                title="End Date"
                translationID="gate.create.name"
                answer={list?.end_date}
                handleValueChange={(a, b) => handleAnswerChanged(a, b)}
                showFieldErrors={fieldErrors.end_date && showErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
              />
            )}
          </div>
          {dateValidationError === 'dates' && (
              <span style={{ color: 'red', fontSize: '11px' }}>
                <FormattedMessage
                  id="pulpoforms.errors"
                  defaultMessage="*Please Make Sure start Date is before end Date"
                />
              </span>
            )}
          <div className={styles.halfformfield}>
            <PulpoField
              key="group_name"
              id="group_name"
              type="string"
              translationID="gate.create.name"
              title="Group Name"
              answer={list?.group_name}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.group_name && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <PulpoField
              key="type_service"
              id="type_service"
              type="string"
              translationID="gate.create.serial"
              title="Type Service"
              answer={list?.type_service}
              handleValueChange={(a, b) => handleAnswerChanged(a, b)}
              showFieldErrors={fieldErrors.type_service && showErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            action="teritory"
            onClick={() => history.push('/gateManagement')}
            translationID="tenants.new.Cancel"
            defaultText="Cancel"
          />
          <Button
            action="secondary"
            onClick={handleEdit}
            translationID="workorders.edit.update"
            defaultText="Update"
          />
        </div>
      </Panel>
    </div>
  );
};

PlanDataUpdate.propTypes = {
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  detail: state.gate.detail,
  updateAction: state.gate.updateAction
});

const mapDispatchToProps = dispatch => ({
  actiongetDetail: (id) => {
    dispatch(getdetail(id));
  },
  actionUpdate: (id, data) => {
    dispatch(updateData(id, data));
  },
  actionClear: () => {
    dispatch(clearData());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PlanDataUpdate);
